<template>
    <div id="MainSection" v-inview:animate="'fadeIn'">
      <img class="title-img" :src="require('@/assets/images/marketing/detail.png')"/>
      <div class="comment1">
        ※ 마케팅 서비스 이용료 차감 후 지급 <br>
        ※ 서비스 이용 기간에 따라 대출금은 상이할 수 있습니다.
      </div>
      <div class="comment2">
        ※ 본 대출은 하단의 마케팅 서비스 이용 고객에 한해 진행됩니다.
      </div>
    </div>
</template>

<script>

export default {
  name: 'MainSection',
}
</script>
<style lang="scss" scoped>
  #MainSection {
    padding-top: 8.498vh;
    padding-left: 2.82vw;
    padding-right: 2.82vw;
    .title-img {
      width: 100%;
    }
    .comment1 {
        padding-top: 20px;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 1.43;
        letter-spacing: -0.43px;
        padding-left: 0;
        padding-right: 0;

    }
    .comment2 {
        font-size: 1.2rem;
        color: red;
        font-weight: 400;
        line-height: 1.43;
        letter-spacing: -0.43px;
        padding-left: 0;
        padding-right: 0;

    }
  }
</style>
